import { MessageHandler } from '@bigcommerce/page-builder-sdk';

import toggleEditMode from './toggleEditMode/toggleEditMode';
import updateProps from './updateProps/updateProps';

const handlers: MessageHandler[] = [toggleEditMode, updateProps];
export default handlers;
